import { render } from "./productos.vue?vue&type=template&id=52377222&scoped=true"
import script from "./productos.vue?vue&type=script&lang=js"
export * from "./productos.vue?vue&type=script&lang=js"

import "./productos.vue?vue&type=style&index=0&id=52377222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52377222"]])

export default __exports__